module.exports = __webpack_public_path__ + "img/scene-bg-2.2fa1bf1a.png";